import React, { ChangeEvent, FC, useState } from 'react';
import { Checkbox, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import {
  Autocomplete,
  AutocompleteRenderInputParams,
  AutocompleteRenderOptionState,
} from '@material-ui/lab';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

import { ContentType, SearchPostsFilter } from 'api';
import { PickerInput, PopupIcon } from 'components/Pickers';
import useAutoCompleteStyles from 'components/Pickers/styles/useAutoCompleteStyles';
import { RemoveIcon } from 'components';

interface Props {
  filters: SearchPostsFilter;
  setFilters: (filters: SearchPostsFilter) => void;
}

const PostType: FC<Props> = ({ filters, setFilters }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const autocompleteClasses = useAutoCompleteStyles();
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  function toggleOpen() {
    setOpen(!open);
  }

  function onChange(event: ChangeEvent, newSelectedOptions: ContentType[]) {
    setInputValue('');
    setFilters({ ...filters, content_types: newSelectedOptions });
  }

  function onChangeInput(nextValue: string) {
    setInputValue(nextValue);
  }

  function onClickDeleteIcon() {
    setFilters({ ...filters, content_types: [] });
  }

  function renderOption(option: ContentType, { selected }: AutocompleteRenderOptionState) {
    return (
      <Grid container alignItems="center">
        <Grid item xs>
          {option}
        </Grid>

        <Grid item>
          <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />
        </Grid>
      </Grid>
    );
  }

  function renderInput(params: AutocompleteRenderInputParams) {
    return (
      <PickerInput
        working={false}
        placeholder={!filters.content_types.length ? t('common:all') : null}
        onChange={onChangeInput}
        params={params}
      />
    );
  }

  return (
    <Grid container alignItems="center">
      <Grid item xs={3}>
        <Typography variant="body2">{t('admin:postType')}</Typography>
      </Grid>

      <Grid item xs={8}>
        <Autocomplete
          value={filters.content_types ?? []}
          classes={autocompleteClasses}
          fullWidth
          multiple
          disableClearable
          disableCloseOnSelect
          open={open}
          onOpen={toggleOpen}
          onClose={toggleOpen}
          renderInput={renderInput}
          renderOption={renderOption}
          options={[ContentType.Photo, ContentType.Link, ContentType.Text, ContentType.Video]}
          inputValue={inputValue}
          onChange={onChange}
          popupIcon={<PopupIcon open={open} />}
        />
      </Grid>

      {!!filters.content_types.length && (
        <Grid item xs={1} container justify="center">
          <RemoveIcon onClick={onClickDeleteIcon} lighter />
        </Grid>
      )}
    </Grid>
  );
};

export default PostType;
